// src/context/ReceiptsVisibilityContext.jsx
import React, { createContext, useContext, useMemo, useState } from 'react';

const Ctx = createContext({ show: false, setShow: () => {} });

export function ReceiptsVisibilityProvider({ value, initial = false, children }) {
  // internal state for uncontrolled usage (fallback)
  const [internal, setInternal] = useState(!!initial);

  // if `value` is provided, we’re controlled; else use internal state
  const controlled = typeof value === 'boolean';
  const show = controlled ? value : internal;
  const setShow = controlled ? () => {} : setInternal;

  const ctx = useMemo(() => ({ show, setShow }), [show]);
  return <Ctx.Provider value={ctx}>{children}</Ctx.Provider>;
}

export function useReceiptsVisibility() {
  return useContext(Ctx);
}
